const normalItems = [
  { text: 'Sadece görünür', icon: 'ri-eye-line' },
  { text: 'Veri yok', icon: 'ri-database-2-line' },
  { text: 'Analiz yok', icon: 'ri-bar-chart-line' },
  { text: 'Yönlendirme yok', icon: 'ri-route-line' },
  { text: 'Reklam bağlantısı yok', icon: 'ri-megaphone-line' },
  { text: 'Statik içerik', icon: 'ri-file-text-line' },
];

const smartItems = [
  { text: 'Kampanya odaklı tasarım', icon: 'ri-focus-3-line' },
  { text: 'Funnel yapısı', icon: 'ri-filter-3-line' },
  { text: 'Veri toplar', icon: 'ri-database-2-line' },
  { text: 'Analiz eder', icon: 'ri-bar-chart-2-line' },
  { text: 'Reklam bağlanır', icon: 'ri-megaphone-line' },
  { text: 'Ziyaretçiyi yönlendirir', icon: 'ri-route-line' },
];

export default function ComparisonSection() {
  return (
    <section id="karsilastirma" className="relative py-20 md:py-28 bg-[#0a0a0f] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_#d4af3708_0%,_transparent_70%)] pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/10 bg-white/5 text-white/60 text-xs font-semibold uppercase tracking-widest mb-5">
            <i className="ri-scales-3-line"></i>
            Karşılaştırma
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight">
            Normal Site mi,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f4d03f]">
              Satış Sistemi mi?
            </span>
          </h2>
          <p className="text-white/50 text-base max-w-xl mx-auto">
            Fark sadece tasarımda değil. Fark, ziyaretçinin ne yaptığında.
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {/* Normal Site */}
          <div className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-7 md:p-9 overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-white/5 via-white/10 to-white/5" />
            <div className="flex items-center gap-3 mb-7">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5">
                <i className="ri-global-line text-white/30 text-xl"></i>
              </div>
              <div>
                <div className="text-white/50 font-bold text-base">Normal Site</div>
                <div className="text-white/25 text-xs">Geleneksel yaklaşım</div>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              {normalItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3 py-2.5 px-3 rounded-lg bg-white/[0.02] border border-white/5">
                  <div className="w-7 h-7 flex items-center justify-center rounded-md bg-red-500/10 flex-shrink-0">
                    <i className={`${item.icon} text-red-400/60 text-sm`}></i>
                  </div>
                  <span className="text-white/35 text-sm line-through decoration-white/20">{item.text}</span>
                  <i className="ri-close-line text-red-400/50 ml-auto text-sm"></i>
                </div>
              ))}
            </div>
            <div className="mt-6 p-4 rounded-xl bg-white/[0.02] border border-white/5 text-center">
              <div className="text-white/25 text-sm">Sonuç: Ziyaretçi gelir, bakar, gider.</div>
            </div>
          </div>

          {/* Smart Pro Platform */}
          <div className="relative rounded-2xl border border-[#d4af37]/30 bg-[#d4af37]/[0.03] p-7 md:p-9 overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#d4af37]/0 via-[#d4af37]/60 to-[#d4af37]/0" />
            <div className="absolute top-4 right-4">
              <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/30">
                <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37] animate-pulse inline-block" />
                <span className="text-[#d4af37] text-xs font-bold">Aktif</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mb-7">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#d4af37]/15">
                <i className="ri-rocket-2-line text-[#d4af37] text-xl"></i>
              </div>
              <div>
                <div className="text-white font-bold text-base">Smart Pro Platform</div>
                <div className="text-[#d4af37]/60 text-xs">Satış odaklı sistem</div>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              {smartItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3 py-2.5 px-3 rounded-lg bg-[#d4af37]/[0.05] border border-[#d4af37]/15 hover:border-[#d4af37]/30 transition-all duration-200">
                  <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#d4af37]/15 flex-shrink-0">
                    <i className={`${item.icon} text-[#d4af37] text-sm`}></i>
                  </div>
                  <span className="text-white/80 text-sm font-medium">{item.text}</span>
                  <i className="ri-check-line text-[#d4af37] ml-auto text-sm"></i>
                </div>
              ))}
            </div>
            <div className="mt-6 p-4 rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/20 text-center">
              <div className="text-[#d4af37] text-sm font-semibold">Sonuç: Ziyaretçi gelir, yönlendirilir, başvurur.</div>
            </div>
          </div>
        </div>

        {/* Bottom stat */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { value: '3.4x', label: 'Daha fazla başvuru', icon: 'ri-user-add-line', color: '#d4af37' },
            { value: '%68', label: 'Daha yüksek dönüşüm', icon: 'ri-arrow-up-line', color: '#00d9ff' },
            { value: '0', label: 'Tahmin, sadece veri', icon: 'ri-bar-chart-2-line', color: '#25d366' },
          ].map((s, i) => (
            <div key={i} className="rounded-xl border border-white/10 bg-white/[0.03] p-5 text-center hover:border-white/20 transition-all duration-200">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3" style={{ backgroundColor: `${s.color}15` }}>
                <i className={`${s.icon} text-xl`} style={{ color: s.color }}></i>
              </div>
              <div className="text-2xl font-black text-white mb-1">{s.value}</div>
              <div className="text-white/40 text-xs">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
